<template>
  <v-flex class="standingOrders" data-qa="amendstandingorder-flex-q5a3v">
    <v-flex v-if="config && config.type === 'same'" data-qa="amendstandingorder-flex-qiuv4">
      <v-navigation-drawer
        v-model="openPayee"
        :width="450"
        :close-on-click="false"
        absolute
        bottom
        right
        floating
        class="transferFunds--payeeList"
       data-qa="amendstandingorder-navigation-drawer-e24dr8">
        <v-card height="100%" data-qa="amendstandingorder-card-8f6fj">
          <v-toolbar color="white" light data-qa="amendstandingorder-toolbar-wel0mt">
            <v-toolbar-title data-qa="amendstandingorder-toolbar-title-6sfrd4">
              <font v-if="!enablePayeeForm">{{
                $t("transferfunds.selectPayeeLabel")
              }}</font>
              <font v-else>{{ $t("transferfunds.addPayeeHeading") }}</font>
            </v-toolbar-title>
            <v-spacer data-qa="amendstandingorder-spacer-3gpegn"></v-spacer>
            <v-btn
              v-if="!enablePayeeForm"
              icon
              @click.stop="openPayee = !openPayee"
             data-qa="amendstandingorder-btn-d1v0z">
              <v-icon class="material-symbols-outlined" data-qa="amendstandingorder-icon-5bule">close</v-icon>
            </v-btn>
            <v-btn v-else icon @click.stop="closePayeeForm" data-qa="amendstandingorder-btn-mxgl4">
              <v-icon class="material-symbols-outlined" data-qa="amendstandingorder-icon-2je9yp">close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-divider data-qa="amendstandingorder-divider-mcb5rb"  />
          <!-- Own Accounts -->
          <div v-if="isViewPayeePermitted && !enablePayeeForm" data-qa="amendstandingorder-div-02a1x">
            <v-tabs
              v-model="payeeCurrentTab"
              :color="primaryColor"
              grow
             data-qa="amendstandingorder-tabs-rst7ji">
              <v-tabs-slider :color="primaryColor" data-qa="amendstandingorder-tabs-slider-whncih"></v-tabs-slider>
              <v-tab
                v-for="(item, i) in totalPayeeTabs"
                :key="item"
                class="text-capitalize font-weight-bold"
                :data-qa="`amendstandingorder-tab-2j8v0-${i}`"
              >
                {{ item }}
              </v-tab>
            </v-tabs>
          </div>
          <v-tabs-items v-model="payeeCurrentTab" :color="primaryColor" data-qa="amendstandingorder-tabs-items-qqwya">
            <v-tab-item data-qa="amendstandingorder-tab-item-c8pee">
              <v-list-item
                two-line
                v-if="isOwnAccountsOpted && !enablePayeeForm"
               data-qa="amendstandingorder-list-item-acwmow">
                <v-list-item-content data-qa="amendstandingorder-list-item-content-o8r8dk">
                  <v-list-item-title data-qa="amendstandingorder-list-item-title-fb9oqf">
                    <v-text-field
                      v-model="search"
                      :label="$t('transferfunds.accountSearchLabel')"
                      :color="primaryColor"
                      prepend-inner-icon="mdi-magnify"
                      class="transferFunds--custom-textfield"
                      maxlength="20"
                      type="number"
                      clearable
                      filled
                     data-qa="amendstandingorder-text-field-d8ul39"></v-text-field>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list
                two-line
                flat
                v-if="isOwnAccountsOpted && !enablePayeeForm"
                class="mt-n10"
               data-qa="amendstandingorder-list-8anmvrn">
                <v-list-item-group :color="primaryColor" data-qa="amendstandingorder-list-item-group-mt4ob">
                  <v-list-item v-show="!listOfAccountsLoaded" data-qa="amendstandingorder-list-item-352mr">
                    <v-list-item-content data-qa="amendstandingorder-list-item-content-ko6fq">
                      <v-progress-circular data-qa="amendstandingorder-progress-circular-50ro5r"
                        indeterminate
                        :color="primaryColor"
                      />
                    </v-list-item-content>
                  </v-list-item>
                  <div v-if="listOfAccountsLoaded" data-qa="amendstandingorder-div-7eh5vi">
                  <template
                    v-for="(item, index) in filteredItems"
                  >
                    <v-list-item :key="item.heading" @click="togglePayee(item)" :data-qa="`amendstandingorder-list-item-odttrs-${index}`">
                      <v-list-item-content :data-qa="`amendstandingorder-list-item-content-dt8jos-${index}`">
                        <v-list-item-title :data-qa="`amendstandingorder-list-item-title-x0vq4g-${index}`"
                          v-text="formatAccount(item)"
                          class="text--primary"
                        />
                        <v-list-item-subtitle :data-qa="`amendstandingorder-list-item-subtitle-br7fsk-${index}`"
                          v-if="item.accountDescription"
                          v-text="convertToCapitalisedSentence(item.accountDescription)"
                        />
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider :data-qa="`amendstandingorder-divider-12ymb-${index}`"
                      v-if="index + 1 < filteredItems.length"
                      :key="index"
                    />
                  </template>
                  </div>
                </v-list-item-group>
              </v-list>
              <v-divider data-qa="amendstandingorder-divider-apean"></v-divider>
            </v-tab-item>
            <v-tab-item data-qa="amendstandingorder-tab-item-qyr8hd">
              <!-- Payees -->
              <v-list-item
                two-line
                v-if="isViewPayeePermitted && !isOwnAccountsOpted && !enablePayeeForm"
               data-qa="amendstandingorder-list-item-z0cknc">
                <v-list-item-content data-qa="amendstandingorder-list-item-content-kec42r">
                  <v-list-item-title data-qa="amendstandingorder-list-item-title-zfvn9c">
                    <v-text-field
                      v-model="searchPayee"
                      :label="$t('transferfunds.payeeSearchLabel')"
                      :color="primaryColor"
                      prepend-inner-icon="mdi-magnify"
                      class="transferFunds--custom-textfield"
                      clearable
                      filled
                     data-qa="amendstandingorder-text-field-6nta8r"></v-text-field>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list
                v-if="!isOwnAccountsOpted && !enablePayeeForm"
                two-line
                flat
                class="mt-n8"
               data-qa="amendstandingorder-list-pb47k">
                <v-row no-gutters justify="end" class="px-3" data-qa="amendstandingorder-row-jr2dh8">
                  <v-btn
                    v-if="isAddPayeePermitted"
                    @click="enablePayeeForm = true"
                    :color="primaryColor"
                    dark
                    class="text-capitalize py-2 px-4"
                   data-qa="amendstandingorder-btn-ti012f">
                    {{ $t("transferfunds.addPayeeBtn") }}
                  </v-btn>
                </v-row>
                <template v-for="(item, index) in beneficiaryList">
                  <v-list-item :key="item.beneficiaryAccount" @click="togglePayee(item)" :data-qa="`amendstandingorder-list-item-0iedmu-${index}`">
                    <v-list-item-content :data-qa="`amendstandingorder-list-item-content-xvumzk-${index}`">
                      <v-list-item-title
                        v-text="item.beneficiaryReference"
                        class="text--primary"
                        :data-qa="`amendstandingorder-list-item-title-8orsxf-${index}`"></v-list-item-title>
                      <v-list-item-subtitle
                        v-text="`${item.beneficiaryAccount}`"
                        :data-qa="`amendstandingorder-list-item-subtitle-vg71r-${index}`">
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider
                    v-if="index + 1 < beneficiaryList.length"
                    :key="index"
                    :data-qa="`amendstandingorder-divider-lkrvr-${index}`"></v-divider>
                </template>
              </v-list>
              <v-list v-if="enablePayeeForm" data-qa="amendstandingorder-list-nc55nw">
                <v-list-item data-qa="amendstandingorder-list-item-l26yao">
                  <v-list-item-content data-qa="amendstandingorder-list-item-content-cj2llg">
                    <v-form ref="payeeForm" v-model="isPayeeFormValid" data-qa="amendstandingorder-form-dtztd9">
                      <v-text-field
                        v-model="payeeForm.accountName"
                        :label="$t('transferfunds.payeeAccountNameLabel')"
                        :color="primaryColor"
                        :rules="requiredRule"
                        filled
                        class="transferFunds--custom-textfield"
                       data-qa="amendstandingorder-text-field-2b5v8b"></v-text-field>
                      <v-text-field
                        v-model="payeeForm.toAccount"
                        :label="$t('transferfunds.payeeAccNoLabel')"
                        :color="primaryColor"
                        :rules="requiredRule"
                        filled
                        required
                        type="password"
                        onCopy="return false"
                        onpaste="return false"
                        class="transferFunds--custom-textfield"
                       data-qa="amendstandingorder-text-field-z00oj8"></v-text-field>
                      <v-text-field
                        v-model="payeeForm.reEnteredToAccount"
                        :label="$t('transferfunds.payeeReEnterAccNoLabel')"
                        :color="primaryColor"
                        :rules="requiredRule"
                        :error="
                          isNumberMatched(
                            payeeForm.toAccount,
                            payeeForm.reEnteredToAccount
                          )
                        "
                        :error-messages="
                          isNumberMatched(
                            payeeForm.toAccount,
                            payeeForm.reEnteredToAccount
                          )
                            ? $t('transferfunds.errorMsgAccNumMatch')
                            : ''
                        "
                        filled
                        onCopy="return false"
                        onpaste="return false"
                        class="transferFunds--custom-textfield"
                       data-qa="amendstandingorder-text-field-v9i1rd"></v-text-field>
                      <v-row justify="center" class="pa-2" data-qa="amendstandingorder-row-rv4z5za">
                        <v-btn
                          @click="onAddPayee"
                          :color="primaryColor"
                          :disabled="
                            !isPayeeFormValid ||
                            isNumberMatched(
                              payeeForm.toAccount,
                              payeeForm.reEnteredToAccount
                            )
                          "

                          class="white--text text-capitalize py-2 px-4"
                         data-qa="amendstandingorder-btn-ie67ht">
                          {{ $t("transferfunds.confirmAddPayee") }}
                        </v-btn>
                      </v-row>
                    </v-form>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-navigation-drawer>
    </v-flex>
    <v-flex v-if="config && config.type === 'other'" data-qa="amendstandingorder-flex-sjd8le">
      <v-navigation-drawer
        v-model="openPayeeInterBank"
        :width="360"
        :close-on-click="false"
        absolute
        bottom
        right
        floating
        class="transferFunds--payeeList"
       data-qa="amendstandingorder-navigation-drawer-om6fr2">
        <v-card height="100%" data-qa="amendstandingorder-card-1nx8qr">
          <v-toolbar color="white" light data-qa="amendstandingorder-toolbar-ptfevh">
            <v-toolbar-title data-qa="amendstandingorder-toolbar-title-vt8edj">
              <v-list-item-title
                v-if="!enablePayeeFormInterBank && !enableSortCodeSearchFormInterBank"
                class="text-h6"
                 data-qa="amendstandingorder-list-item-title-0f4k7f">{{ $t("domesticPayments.selectPayeeLabel") }}
              </v-list-item-title>
              <v-list-item-title
                v-if="enablePayeeFormInterBank || enableSortCodeSearchFormInterBank"
                class="text-h6"
                 data-qa="amendstandingorder-list-item-title-uhac1r">{{ $t("domesticPayments.addPayeeHeading") }}
              </v-list-item-title>
              <v-list-item-subtitle v-if="enableSortCodeSearchFormInterBank" data-qa="amendstandingorder-list-item-subtitle-brz4d9">
                <font :color="darkColor">{{
                  $t("domesticPayments.searchSortCode")
                }}</font>
              </v-list-item-subtitle>
            </v-toolbar-title>
            <v-spacer data-qa="amendstandingorder-spacer-0zhe3o"></v-spacer>
            <v-btn @click.stop="onClosePayeeDrawerInterBank" icon data-qa="amendstandingorder-btn-sp8ge">
              <v-icon class="material-symbols-outlined" data-qa="amendstandingorder-icon-cemuas">close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-divider data-qa="amendstandingorder-divider-61348"  />
          <!-- Payees -->
          <v-list-item
            two-line
            v-if="isViewPayeePermitted && !enablePayeeFormInterBank && !enableSortCodeSearchFormInterBank"
           data-qa="amendstandingorder-list-item-fh4sd">
            <v-list-item-content data-qa="amendstandingorder-list-item-content-96usl">
              <v-list-item-title data-qa="amendstandingorder-list-item-title-j1v698">
                <v-text-field
                  v-model="searchPayeeInterBank"
                  :label="$t('domesticPayments.payeeSearchLabel')"
                  :color="primaryColor"
                  prepend-inner-icon="mdi-magnify"
                  class="transferFunds--custom-textfield"
                  clearable
                  filled
                 data-qa="amendstandingorder-text-field-h41cy"></v-text-field>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list
            v-if="!enablePayeeFormInterBank && !enableSortCodeSearchFormInterBank"
            two-line
            flat
            class="mt-n8"
           data-qa="amendstandingorder-list-jsf55">
            <v-row no-gutters justify="end" class="px-3" data-qa="amendstandingorder-row-a51hki">
              <v-btn
                v-if="isAddPayeePermitted"
                @click="enablePayeeFormInterBank = true"
                :color="primaryColor"
                dark
                class="text-capitalize py-2 px-4"
               data-qa="amendstandingorder-btn-avwn6">
                {{ $t("domesticPayments.addPayeeBtn") }}
              </v-btn>
            </v-row>
            <v-flex class="mx-5 py-4" data-qa="amendstandingorder-flex-o4tx3d">
              <v-tabs
                :color="primaryColor"
                v-model="showLinkedAccounts"
                class="text-capitalize"
               data-qa="amendstandingorder-tabs-q75fa">
                <v-tab class="text-none font-weight-bold" data-qa="amendstandingorder-tab-w30g0o">
                  {{ $t("payee.linkedAccBtn") }}
                </v-tab>
                <v-tab class="text-none font-weight-bold" data-qa="amendstandingorder-tab-wdbyp8">
                  {{ $t("payee.payeeBtn") }}
                </v-tab>
              </v-tabs>
            </v-flex>
            <template v-for="(item, index) in payeeSearchFilterInterBank">
              <v-list-item
                :key="item.accountIdentification"
                @click="togglePayeeInterBank(item)"
                :data-qa="`amendstandingorder-list-item-ufjumn-${index}`">
                <v-list-item-content :data-qa="`amendstandingorder-list-item-content-mra83j-${index}`">
                  <v-list-item-title
                    v-text="item.name"
                    class="text--primary"
                    :data-qa="`amendstandingorder-list-item-title-glcz5g9-${index}`"></v-list-item-title>
                  <v-list-item-subtitle
                    v-text="
                      `${item.accountIdentification} | ${item.bankIdentifier}`
                    "
                    :data-qa="`amendstandingorder-list-item-subtitle-w20gbgb-${index}`"></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                v-if="showDividerInterBank(index, beneficiaryListInterBank)"
                :key="index"
                :data-qa="`amendstandingorder-divider-rdw5w7-${index}`"></v-divider>
            </template>
          </v-list>
          <v-list v-if="enablePayeeFormInterBank" data-qa="amendstandingorder-list-eooj2">
            <v-list-item data-qa="amendstandingorder-list-item-grpshc">
              <v-list-item-content data-qa="amendstandingorder-list-item-content-9bgnu">
                <v-form ref="payeeFormInterBank" v-model="isPayeeFormValidInterBank" data-qa="amendstandingorder-form-yfqm3">
                  <v-text-field
                    v-model="payeeFormInterBank.accountName"
                    :label="$t('domesticPayments.payeeAccountNameLabel')"
                    :color="primaryColor"
                    :rules="[rules.requiredRule]"
                    :maxlength="payeeFormInterBank.enableMaxPayeeName ? 70 : false"
                    filled
                    class="transferFunds--custom-textfield"
                   data-qa="amendstandingorder-text-field-gmk62i"></v-text-field>
                  <v-text-field
                    v-model="payeeFormInterBank.toAccount"
                    :label="$t('domesticPayments.payeeAccNoLabel')"
                    :color="primaryColor"
                    :rules="[rules.requiredRule]"
                    filled
                    required
                    type="password"
                    onCopy="return false"
                    onpaste="return false"
                    class="transferFunds--custom-textfield"
                    @keydown="$formatter.validateNumberInput($event)"
                   data-qa="amendstandingorder-text-field-vdrvon"></v-text-field>
                  <v-text-field
                    v-model="payeeFormInterBank.reEnteredToAccount"
                    :label="$t('domesticPayments.payeeReEnterAccNoLabel')"
                    :color="primaryColor"
                    :rules="[rules.requiredRule]"
                    :error="
                      isNumberMatchedInterBank(
                        payeeFormInterBank.toAccount,
                        payeeFormInterBank.reEnteredToAccount
                      )
                    "
                    :error-messages="
                      isNumberMatchedInterBank(
                        payeeFormInterBank.toAccount,
                        payeeFormInterBank.reEnteredToAccount
                      )
                        ? $t('domesticPayments.errorMsgAccNumMatch')
                        : ''
                    "
                    filled
                    onCopy="return false"
                    onpaste="return false"
                    class="transferFunds--custom-textfield"
                    @keydown="$formatter.validateNumberInput($event)"
                   data-qa="amendstandingorder-text-field-ir06hx"></v-text-field>
                  <v-layout class="pa-0" data-qa="amendstandingorder-layout-pqkygs">
                    <v-flex xs8 sm8 md8 lg8 xl8 data-qa="amendstandingorder-flex-3rmls8">
                      <v-text-field
                        v-model="payeeFormInterBank.sortCode"
                        :label="$t('addNewPayee.sortCode')"
                        :color="primaryColor"
                        :rules="[rules.requiredWithNoErrRule]"
                        readonly
                        class="transferfunds--nonEditable-textfield"
                       data-qa="amendstandingorder-text-field-735zxa"></v-text-field>
                    </v-flex>
                    <v-flex xs4 sm4 md4 lg4 xl4 class="text-end" data-qa="amendstandingorder-flex-wckuut">
                      <v-btn
                        @click="showSearchFormInterBank"
                        :color="primaryColor"
                        outlined
                        class="text-none subtitle-2 font-weight-regular py-2 px-4"
                       data-qa="amendstandingorder-btn-hyof2">
                        <v-icon class="material-symbols-outlined" data-qa="amendstandingorder-icon-b79kwe">magnify</v-icon>
                        {{ $t("domesticPayments.searchSortCodeBtn") }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-text-field
                    v-model="payeeFormInterBank.bankName"
                    :label="$t('addNewPayee.bankName')"
                    :color="primaryColor"
                    :rules="[rules.requiredWithNoErrRule]"
                    readonly
                    class="transferfunds--nonEditable-textfield"
                   data-qa="amendstandingorder-text-field-gb8xd"></v-text-field>
                  <v-row no-gutters justify="center" class="pa-2" data-qa="amendstandingorder-row-pq86eh">
                    <v-btn
                      @click="onAddPayeeInterBank"
                      :color="primaryColor"
                      :disabled="
                        !isPayeeFormValidInterBank
                      "

                      class="white--text text-capitalize py-2 px-4"
                     data-qa="amendstandingorder-btn-erdkge">
                      {{ $t("domesticPayments.confirmAddPayee") }}
                    </v-btn>
                  </v-row>
                </v-form>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list v-if="enableSortCodeSearchFormInterBank" data-qa="amendstandingorder-list-hl4jn">
            <v-list-item data-qa="amendstandingorder-list-item-kt81dw">
              <v-list-item-content data-qa="amendstandingorder-list-item-content-mcz6aq">
                <v-row no-gutters class="pb-0" data-qa="amendstandingorder-row-bw8a1">
                  <v-alert
                    icon="mdi-information-outline"
                    class="v-alert--info"
                   data-qa="amendstandingorder-alert-0hyr1">
                    <font class="caption font-weight-regular">
                      {{ $t("domesticPayments.searchSortCodeInfo") }}
                    </font>
                  </v-alert>
                </v-row>
                <v-form
                  ref="searchSortCodeForm"
                  v-model="isSortCodeSearchFormValidInterBank"
                 data-qa="amendstandingorder-form-xqjl7">
                  <Form
                    :config="{
                      label: '',
                      name: 'SearchSortCode',
                      isEnabled: true,
                      toolbar: false,
                      form: schema.searchSortCodeForm
                    }"
                  ></Form>
                  <v-row no-gutters justify="center" class="pa-2" data-qa="amendstandingorder-row-tjlco9">
                    <v-btn
                      @click="onSearchSortCodeInterBank"
                      :color="primaryColor"
                      :disabled="isSearchDataValidInterBank()"

                      class="white--text text-capitalize py-2 px-4"
                     data-qa="amendstandingorder-btn-ich53g">
                      {{ $t("domesticPayments.searchBtn") }}
                    </v-btn>
                  </v-row>
                </v-form>
              </v-list-item-content>
            </v-list-item>
            <font
              v-if="sortCodeResultsInterBank.length"
              class="pl-4 text-h6 font-weight-light"
              >{{ $t("domesticPayments.searchResultsTitle") }}</font
            >
            <div v-if="sortCodeResultsInterBank.length" data-qa="amendstandingorder-div-acb9fn">
              <template v-for="(data, index) in sortCodeResultsInterBank">
                <v-list-item :key="data.nationalid" :data-qa="`amendstandingorder-list-item-5tzzd-${index}`">
                  <v-list-item-content :data-qa="`amendstandingorder-list-item-content-c6es7a-${index}`">
                    <v-flex xs8 sm8 md8 lg8 xl8 :data-qa="`amendstandingorder-flex-fq7hmq-${index}`">
                      <v-list-item-title :data-qa="`amendstandingorder-list-item-title-tw0h84-${index}`">
                        <font class="body-2 font-weight-light">{{
                          convertToCapitalised(data.instname)
                        }}</font>
                      </v-list-item-title>
                      <v-list-item-subtitle :data-qa="`amendstandingorder-list-item-subtitle-xj6swp-${index}`">
                        <font class="caption">
                          {{ convertToCapitalised(data.branchinfo) }}
                        </font>
                      </v-list-item-subtitle>
                      <v-list-item-subtitle :data-qa="`amendstandingorder-list-item-subtitle-07gvp-${index}`">
                        <font class="caption font-weight-bold">{{
                          $t("domesticPayments.sortCodeLabel")
                        }}</font
                        ><font class="caption font-weight-bold">{{
                          maskSortCodeInterBank(data.nationalid)
                        }}</font>
                      </v-list-item-subtitle>
                    </v-flex>
                    <v-flex xs4 sm4 md4 lg4 xl4 class="text-end" :data-qa="`amendstandingorder-flex-x1wva-${index}`">
                      <v-btn
                        @click="onSortCodeSelectInterBank(data)"
                        :color="primaryColor"
                        outlined
                        class="text-none py-2 px-4"
                        :data-qa="`amendstandingorder-btn-fynaqib-${index}`">
                        {{ $t("domesticPayments.selectBtn") }}
                      </v-btn>
                    </v-flex>
                  </v-list-item-content>
                </v-list-item>
                <v-divider
                  v-if="showDividerInterBank(index, sortCodeResultsInterBank)"
                  :key="index"
                  :data-qa="`amendstandingorder-divider-dr9fw-${index}`"></v-divider>
              </template>
            </div>
            <div
              v-if="
                !searchSortCodeForm.isSearchAvailable && !sortCodeResultsInterBank.length
              "
             data-qa="amendstandingorder-div-zaldep">
              <font class="pl-4 text-h6 font-weight-light">{{
                $t("domesticPayments.searchResultsTitle")
              }}</font>
              <v-list-item data-qa="amendstandingorder-list-item-9eoee">
                <font class="body-2 font-weight-light">{{
                  $t("domesticPayments.noSortCode")
                }}</font>
              </v-list-item>
            </div>
          </v-list>
        </v-card>
      </v-navigation-drawer>
    </v-flex>
    <v-layout wrap class="ml-2 standingOrders--gradientBGposition" data-qa="amendstandingorder-layout-o678g3">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient, height: '180px' }"
       data-qa="amendstandingorder-flex-18aupn">
        <v-container class="standingOrders--title-padding" data-qa="amendstandingorder-container-4lp7wn">
          <v-flex xs12 sm12 md12 lg12 xl12 data-qa="amendstandingorder-flex-8q09f">
            <v-row no-gutters data-qa="amendstandingorder-row-1j4vp">
              <v-layout row wrap class="pb-2 pl-12" data-qa="amendstandingorder-layout-77tx6n">
                    <div class="pt-3" data-qa="amendstandingorder-div-kwju1">
                    <v-avatar :tile="false" size="35" color="white" data-qa="amendstandingorder-avatar-za82j3">
                      <v-icon :color="primaryColor" data-qa="amendstandingorder-icon-es75d">mdi-file-multiple-outline</v-icon>
                    </v-avatar>
                    </div>
                <v-flex xs9 sm9 md9 lg9 xl9 class="pt-4 pl-2" data-qa="amendstandingorder-flex-8qqlkb">
                  <v-row no-gutters data-qa="amendstandingorder-row-a4aeof">
                    <font class="text-h5 font-weight-light white--text">
                      {{ $t("recurringAndFuturePayments.recurring")}}  &
                      {{ $t("recurringAndFuturePayments.futurePayments")}}</font
                    >
                  </v-row>
                </v-flex>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>
    <v-flex
      xs12
      sm12
      md10
      lg10
      xl10
      class="standingOrders--content-padding standingOrders--overlayCardFlex"
     data-qa="amendstandingorder-flex-h4gcgx">
      <v-layout row wrap class="standingOrders--content-padding" data-qa="amendstandingorder-layout-o0sajw">
        <v-flex
          sm12
          xs12
          md12
          lg12
          xl12
          class="hidden-lg-and-up bottom--pb10"
         data-qa="amendstandingorder-flex-fy0u1g">
          <v-btn
            v-if="!futurePayment"
            color="white"
            class="text-none px-4 py-2"
            outlined
            @click="navigateToList(true)"
             data-qa="amendstandingorder-btn-pkzj">{{$t('recurringAndFuturePayments.gotoRecurringPaymentsBtn')}}</v-btn
          >
          <v-btn
            v-else
            color="white"
            class="text-none px-4 py-2"
            outlined
            @click="navigateToList(true)"
             data-qa="amendstandingorder-btn-tiaqug">{{$t('recurringAndFuturePayments.gotoFuturePaymentsBtn')}}</v-btn
          >
        </v-flex>
        <v-flex xs10 sm10 md10 lg10 xl10 class="pt-0" data-qa="amendstandingorder-flex-1i0sf">
          <!-- 1st Tab -->
          <v-layout data-qa="amendstandingorder-layout-lulcsn">
          <!-- 2nd Tab -->
          <v-flex xs12 sm12 md12 lg12 xl12 data-qa="amendstandingorder-flex-ludw6s">
          <v-card v-if="config && config.type === 'same'" width="700" data-qa="amendstandingorder-card-it9ewt">
            <v-container data-qa="amendstandingorder-container-9zzlr">
              <v-layout row justify-space-between data-qa="amendstandingorder-layout-1fsoia">
                  <v-flex xs12 sm12 md12 lg12 xl12 data-qa="amendstandingorder-flex-k234wp">
                   <v-col cols="6" class="px-6 pt-3" data-qa="amendstandingorder-col-i2f28l">
                    <font v-if="!futurePayment" class="text-h6 font-weight-light" style="opacity:0.7">{{$t('recurringAndFuturePayments.amendRecurringPaymentsLabel')}}</font>
                    <font v-else class="text-h6 font-weight-light" style="opacity:0.7">{{$t('recurringAndFuturePayments.amendFuturePaymentsLabel')}}</font>
                   </v-col>
                  </v-flex>
                  <v-form
                          v-if="renderComponent"
                          v-model="isFormValid"
                          :lazy-validation="false"
                          ref="paymentForm"
                         data-qa="amendstandingorder-form-wko22f">
                        <v-layout row justify-space-between data-qa="amendstandingorder-layout-hba3v9">
                  <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3 pb-0" data-qa="amendstandingorder-flex-fa9jso">
                              <v-text-field
                                v-model="selectedAccountNumber"
                                :color="primaryColor"
                                :label="$t('recurringAndFuturePayments.fromAccount')"
                                :error="isFormAccounts"
                                :error-messages="
                                  isFormAccounts
                                    ? $t('transferfunds.accountsError')
                                    : ''
                                "
                                :rules="requiredRule || !isFormAccounts"
                                readonly
                                class="standingOrders--nonEditable-textfield"
                               data-qa="amendstandingorder-text-field-a72a9"></v-text-field>
                            </v-flex>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="amendstandingorder-flex-zvv2w">
                              <v-text-field
                                v-if="!futurePayment"
                                v-model="payeeList"
                                @click="listPayee"
                                :color="primaryColor"
                                :rules="requiredRule || !isFormAccounts"
                                :label="$t('transferfunds.selectPayeeLabel')"
                                filled
                                append-icon="mdi-chevron-right"
                                class="standingOrders--custom-textfield"
                               data-qa="amendstandingorder-text-field-x1p8n9"></v-text-field>
                              <v-text-field
                                v-else
                                v-model="selectedToAccountNumber"
                                :color="primaryColor"
                                :rules="requiredRule || !isFormAccounts"
                                :label="$t('transferfunds.selectPayeeLabel')"
                                readonly
                                class="standingOrders--nonEditable-textfield"
                               data-qa="amendstandingorder-text-field-13dol"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="amendstandingorder-flex-2wjy8a">
                              <v-text-field
                                v-model="amount"
                                type="number"
                                :color="primaryColor"
                                :label="$t('recurringAndFuturePayments.amount')"
                                :error="isFromAccountBalance"
                                :error-messages="
                                  isFromAccountBalance
                                    ? $t('recurringAndFuturePayments.amountValidation')
                                    : ''
                                "
                                filled
                                :rules="[rules.requiredAmountRule, rules.numberTypeCheck, rules.isAccBalanceValid]"
                                :prefix="
                                  $formatter.currency.getCurrencySymbol(config.transferToAccountDetails[0].amount.currency)
                                "
                                @input="validateBalance()"
                                class="standingOrders--custom-textfield"
                               data-qa="amendstandingorder-text-field-wuk816"></v-text-field>
                            </v-flex>
                            <v-flex
                              v-if="!futurePayment"
                              xs12
                              sm12
                              md6
                              lg6
                              xl6
                              class="px-6 pt-3"
                             data-qa="amendstandingorder-flex-w887x">
                              <v-text-field
                                v-model="paymentFrequency"
                                :label="$t('transferfunds.frequencyDaysLabel')"
                                :items="frequencyDays"
                                :color="primaryColor"
                                :rules="requiredRule"
                                autocomplete
                                return-object
                                readonly
                                item-text="state"
                                item-value="val"
                                item-key="val"
                                max-height="auto"
                                data-qa="paymentFrequency"
                                class="standingOrders--nonEditable-textfield"
                              ></v-text-field>
                            </v-flex>
                            <v-flex v-if="!futurePayment" xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="amendstandingorder-flex-928ufh">
                              <v-text-field
                                v-model="formattedDate"
                                :color="primaryColor"
                                :label="$t('transferfunds.paymentDateLabel')"
                                :rules="requiredRule"
                                readonly
                                class="standingOrders--nonEditable-textfield"
                               data-qa="amendstandingorder-text-field-h6uf0i"></v-text-field>
                            </v-flex>
                            <v-flex v-if="!futurePayment && config.endDate" xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="amendstandingorder-flex-vhibm">
                              <v-menu
                                v-model="endDateMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                offset-y
                                transition="scale-transition"
                                min-width="290px"
                               data-qa="amendstandingorder-menu-feoqe8">
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    v-on="on"
                                    v-model="formattedEndDate"
                                    label="Payment End Date"
                                    :color="primaryColor"
                                    :rules="requiredRule"
                                    :error="isValidateEndDate"
                                    :error-messages="
                                    isValidateEndDate
                                    ? $t('recurringAndFuturePayments.validateEndDate')
                                    : ''
                                    "
                                    filled
                                    readonly
                                    data-qa="endDate"
                                    append-icon="mdi-calendar"
                                    class="standingOrders--custom-textfield"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="endDate"
                                  @input="endDateMenu = false"
                                  :allowed-dates="allowedDates"
                                  :min="minAllowedDate"
                                  :color="primaryColor"
                                  @change="updateEndDate"
                                  filled
                                  data-qa="endDate"
                                ></v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex v-if="!futurePayment && config.numberOfPayments" xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="amendstandingorder-flex-mxqxo">
                              <v-text-field
                                v-model="noOfPaymentsIntraBank"
                                :color="primaryColor"
                                :label="$t('recurringAndFuturePayments.numberOfPayments')"
                                filled
                                class="standingOrders--custom-textfield"
                                type="number"
                                :rules="noOfPaymentsIntraBank ? [rules.requiredRule, rules.minValue, rules.maxValue] : [rules.requiredRule]"
                               data-qa="amendstandingorder-text-field-l0309o"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="amendstandingorder-flex-80ov2d">
                              <v-text-field
                                    v-model="formattedNextPaymentDate"
                                    :label="futurePayment ? $t('recurringAndFuturePayments.paymentDate'):$t('recurringAndFuturePayments.nextPaymentDate')"
                                    :color="primaryColor"
                                    readonly
                                    data-qa="nextPaymentDate"
                                    class="standingOrders--nonEditable-textfield"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="amendstandingorder-flex-zvls3h">
                              <v-text-field
                                v-model="description"
                                :color="primaryColor"
                                :label="!futurePayment ? $t('recurringAndFuturePayments.description') : $t('recurringAndFuturePayments.remarks')"
                                :maxlength="intraBankRemarksMaxlength"
                                :rules="[rules.remarksFieldRule]"
                                filled
                                class="standingOrders--custom-textfield"
                               data-qa="amendstandingorder-text-field-t9gx9e"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row justify-space-between data-qa="amendstandingorder-layout-u9m3nv">
                            <v-flex xs11 sm11 md5 lg5 xl5 class="pl-4 py-2" data-qa="amendstandingorder-flex-okoe9h">
                              <v-btn
                                class="text-capitalize ma-2 white--text py-2 px-4"
                                :color="primaryColor"
                                :disabled="!isFormValid"
                                elevation="2"
                                @click="setOtpComp()"
                                 data-qa="amendstandingorder-btn-rvdho9">{{
                                  $t("recurringAndFuturePayments.confirm")
                                }}</v-btn
                              >
                            </v-flex>
                          </v-layout>
                  </v-form>
              </v-layout>
            </v-container>
          </v-card>
          <v-card v-else width="700" data-qa="amendstandingorder-card-9hmagu">
            <v-container data-qa="amendstandingorder-container-zrvvq">
              <v-layout row justify-space-between data-qa="amendstandingorder-layout-kihncs">
                  <v-flex xs12 sm12 md12 lg12 xl12 data-qa="amendstandingorder-flex-vecmoh">
                   <v-col cols="6" class="px-6 pt-3" data-qa="amendstandingorder-col-eotpru">
                    <font v-if="!futurePayment" class="text-h6 font-weight-light" style="opacity:0.7">{{$t('recurringAndFuturePayments.amendRecurringPaymentsLabel')}}</font>
                    <font v-else class="text-h6 font-weight-light" style="opacity:0.7">{{$t('recurringAndFuturePayments.amendFuturePaymentsLabel')}}</font>
                   </v-col>
                  </v-flex>
                  <v-form
                    v-model="isInterBankFormValid"
                    :lazy-validation="false"
                    ref="paymentForm"
                   data-qa="amendstandingorder-form-4kbjyj">
                    <v-layout row justify-space-between data-qa="amendstandingorder-layout-ofdkus">
                      <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3 pb-0" data-qa="amendstandingorder-flex-bzpmf">
                        <v-text-field
                          v-model="interBankFromAccount"
                          :color="primaryColor"
                          :label="$t('recurringAndFuturePayments.fromAccount')"
                          :error="isFormAccounts"
                          :error-messages=" isFormAccounts ? $t('transferfunds.accountsError') : ''"
                          :rules="requiredRule || !isFormAccounts"
                          readonly
                          class="standingOrders--nonEditable-textfield"
                         data-qa="amendstandingorder-text-field-6ua0e"></v-text-field>
                      </v-flex>
                      <v-flex v-if="!futurePayment" xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="amendstandingorder-flex-9pvii">
                        <v-text-field
                          v-model="payeeListInterBank"
                          :color="primaryColor"
                          :rules="[rules.requiredRule || !isFormAccounts]"
                          :label="$t('domesticPayments.selectPayeeLabel')"
                          :hint="
                            payeeAccountName && selectedPayeeSortCode
                              ? `${payeeAccountName} | ${selectedPayeeSortCode}`
                              : payeeAccountName ? `${payeeAccountName}` : selectedPayeeSortCode ? `${selectedPayeeSortCode}` : `${payeeAccount}`
                          "
                          persistent-hint
                          filled
                          readonly
                          append-icon="mdi-chevron-right"
                          class="standingOrders--nonEditable-textfield"
                         data-qa="amendstandingorder-text-field-1w01n"></v-text-field>
                      </v-flex>
                      <v-flex v-if="futurePayment" xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="amendstandingorder-flex-05af5s">
                         <v-text-field
                          v-model="payeeListInterBank"
                          :color="primaryColor"
                          :rules="[rules.requiredRule || !isFormAccounts]"
                          :label="$t('domesticPayments.selectPayeeLabel')"
                          :hint="
                            payeeAccountName && selectedPayeeSortCode
                              ? `${payeeAccountName} | ${selectedPayeeSortCode}`
                              : payeeAccountName ? `${payeeAccountName}` : selectedPayeeSortCode ? `${selectedPayeeSortCode}` : `${payeeAccount}`
                          "
                          persistent-hint
                          filled
                          readonly
                          class="standingOrders--nonEditable-textfield"
                         data-qa="amendstandingorder-text-field-d8mf8"></v-text-field>
                        </v-flex>
                            <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="amendstandingorder-flex-1j7ffa">
                              <v-text-field
                                v-model="interBankAmount"
                                type="number"
                                :color="primaryColor"
                                :label="$t('recurringAndFuturePayments.amount')"
                                :error="isFromAccountBalance"
                                :error-messages="
                                  isFromAccountBalance
                                    ? $t('recurringAndFuturePayments.amountValidation')
                                    : ''
                                "
                                filled
                                :hint="getInterBankAmountLimit"
                                :rules="[rules.requiredAmountRule, rules.numberTypeCheck, rules.isAccBalanceValid, rules.isLimitValid]"
                                :prefix="
                                  $formatter.currency.getCurrencySymbol(config.paymentInstruction.instructionAmount.currency)
                                "
                                @input="validateBalance('interBankAmount')"
                                class="standingOrders--custom-textfield"
                               data-qa="amendstandingorder-text-field-k43cds"></v-text-field>
                            </v-flex>
                            <v-flex
                              v-if="!futurePayment"
                              xs12
                              sm12
                              md6
                              lg6
                              xl6
                              class="px-6 pt-3"
                             data-qa="amendstandingorder-flex-da90x8">
                              <v-autocomplete
                                v-model="interBankPaymentFrequency"
                                :label="$t('transferfunds.frequencyDaysLabel')"
                                :items="frequencyDays"
                                :color="primaryColor"
                                :rules="requiredRule"
                                autocomplete
                                filled
                                return-object
                                item-text="state"
                                item-value="val"
                                item-key="val"
                                max-height="auto"
                                data-qa="paymentFrequency"
                                class="standingOrders--nonEditable-textfield"
                                readonly
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex v-if="!futurePayment" xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="amendstandingorder-flex-89hj">
                              <v-text-field
                                v-model="formattedInterBankPaymentDate"
                                :color="primaryColor"
                                :label="$t('transferfunds.paymentDateLabel')"
                                :rules="requiredRule"
                                readonly
                                class="standingOrders--nonEditable-textfield"
                               data-qa="amendstandingorder-text-field-hdsv5"></v-text-field>
                            </v-flex>
                            <v-flex v-if="!futurePayment" xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="amendstandingorder-flex-xqae7c">
                              <v-text-field
                                v-model="noOfPayments"
                                type = "number"
                                :color="primaryColor"
                                label="Number of payments"
                                filled
                                class="standingOrders--custom-textfield"
                                :rules="noOfPayments ? [rules.requiredRule, rules.minValue, rules.maxValue] : [rules.requiredRule]"
                               data-qa="amendstandingorder-text-field-730je"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="amendstandingorder-flex-jwe42">
                              <v-text-field
                                    v-model="nextExecutionDate"
                                    :label="futurePayment ? $t('recurringAndFuturePayments.paymentDate'):$t('recurringAndFuturePayments.nextPaymentDate')"
                                    :color="primaryColor"
                                    readonly
                                    data-qa="nextPaymentDate"
                                    class="standingOrders--nonEditable-textfield"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="amendstandingorder-flex-y7kmx">
                              <v-text-field
                                v-model="interBankPaymentDescription"
                                :color="primaryColor"
                                :label="!futurePayment ? $t('recurringAndFuturePayments.description') : $t('recurringAndFuturePayments.remarks')"
                                filled
                                :maxlength="!isUKFPSAccount ? sepaRemarksMaxlength : ukfpsRemarksMaxlength"
                                class="standingOrders--custom-textfield"
                                :rules="!isUKFPSAccount ? [
                                    rules.transferNoteValidation,rules.requiredRule
                                  ] : [rules.remarksFieldRule]"
                               data-qa="amendstandingorder-text-field-zcvy4w"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row justify-space-between data-qa="amendstandingorder-layout-tyo3om">
                            <v-flex xs11 sm11 md5 lg5 xl5 class="pl-4 py-2" data-qa="amendstandingorder-flex-dcdop">
                              <v-btn
                                class="text-capitalize ma-2 white--text py-2 px-4"
                                :color="primaryColor"
                                :disabled="!isInterBankFormValid"
                                elevation="2"
                                @click="setOtpComp()"
                                 data-qa="amendstandingorder-btn-egflo9">{{
                                  $t("recurringAndFuturePayments.confirm")
                                }}</v-btn
                              >
                            </v-flex>
                          </v-layout>
                  </v-form>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
        <v-flex
          sm12
          xs12
          md12
          lg12
          xl12
          class="hidden-md-and-down standingOrders--newBill"
          style="align-items:end;margin-bottom:40px;margin-left:20px;"
         data-qa="amendstandingorder-flex-ge4w9k">
          <v-btn
            v-if="!futurePayment"
            color="white"
            class="text-none px-4 py-2"
            outlined
            @click="navigateToList(true)"
             data-qa="amendstandingorder-btn-23rn0r">{{$t('recurringAndFuturePayments.gotoRecurringPaymentsBtn')}}</v-btn
          >
          <v-btn
            v-else
            color="white"
            class="text-none px-4 py-2"
            outlined
            @click="navigateToList(true)"
             data-qa="amendstandingorder-btn-376ojg">{{$t('recurringAndFuturePayments.gotoFuturePaymentsBtn')}}</v-btn
          >
        </v-flex>
      </v-layout>
        </v-flex>
      </v-layout>
    <Modal
      v-if="enableOTPToAddPayee && showOTPScreen && config.type === 'other' && addPayeeOtherBank"
      @cancel="onOtpModalClose"
      :config="modalConfig.otp"
    >
      <span slot="modalContent" data-qa="amendstandingorder-span-pbmhm">
        <OtpInput :otpConfig="otpSettings" />
      </span>
    </Modal>
      <!-- For OTP -->
    <!-- OTP Section -->
    <Modal
      v-if="!enablePaymentPage && !this.futurePayment && enableOTPForRecurringPayments && showOTPScreen  && config.type === 'same'"
      :config="modalConfig.otp"
      @cancel="onOtpModalClose"
    >
      <span slot="modalContent" data-qa="amendstandingorder-span-qv7do">
        <OtpInput :otpConfig="otpSettings" />
      </span>
    </Modal>
    <!-- Recurring Payments Inter Bank OTP -->
    <Modal
      v-if="!enablePaymentPage && !this.futurePayment && enableOTPForRecurringPayments && showOTPScreen  && config.type === 'other' && !addPayeeOtherBank"
      :config="modalConfig.otp"
      @cancel="onOtpModalClose"
    >
      <span slot="modalContent" data-qa="amendstandingorder-span-uafobn">
        <OtpInput :otpConfig="otpSettings" />
      </span>
    </Modal>
    <Modal
      v-if="!enablePaymentPage && this.futurePayment && enableOTPForFuturePayments && showOTPScreen  && config.type === 'same'"
      :config="modalConfig.otp"
      @cancel="onOtpModalClose"
    >
      <span slot="modalContent" data-qa="amendstandingorder-span-14ag6u">
        <OtpInput :otpConfig="otpSettings" />
      </span>
    </Modal>
    <Modal
      v-if="!enablePaymentPage && this.futurePayment && enableOTPForFuturePayments && showOTPScreen  && config.type === 'other'"
      :config="modalConfig.otp"
      @cancel="onOtpModalClose"
    >
      <span slot="modalContent" data-qa="amendstandingorder-span-1em3g">
        <OtpInput :otpConfig="otpSettings" />
      </span>
    </Modal>
    <Modal
      v-if="enableOTPToAddPayee  && !this.futurePayment && showOTPScreen && payeeOtpModal"
      @cancel="onOtpModalClose"
      :config="modalConfig.otp"
    >
      <span slot="modalContent" data-qa="amendstandingorder-span-nc796">
        <OtpInput :otpConfig="otpSettings" />
      </span>
    </Modal>
    <Modal
      v-if="showConfirmationModal"
      :config='getPaymentSuccessDialogConfig'
      @btn1Action="navigateToList(true)"
      @btn2Action="navigateToDashboard()">
      >
    </Modal>
    </v-flex>
  </v-flex>
</template>

<script>
import _ from 'lodash'
import '@/styles/pages/login/login.scss'
import '@/styles/pages/transferFunds.scss'
import preload from '@/util/preload'
import '@/styles/pages/standingOrders.scss'
import { minLen } from '@/core/_helpers/validationRules'
import getFormConfig from '@/util/formUtility.js'
import event from '@/util/event'
import moment from 'moment'
import OtpInput from '@/components/common/OtpInput.vue'
import CommonService from '@/service/commonService.js'
import UKFPSpayemntTemplate from '@/plugins/UKFPSconfig'
import SEPAPaymentTemplate from '@/plugins/SEPAconfig'
import store from '@/core/store'
import { getAccountTypeLabel } from '../../../util/accountUtil'

export default {
  name: 'AmendStandingOrder',
  components: {
    OtpInput,
    Modal: () => import('@/components/common/Modal.vue'),
    Form: () => import('@/components/DOB-Form/Form.vue')
  },
  props: {
    amendConfig: {
      type: Object,
      default: undefined
    }
  },
  data () {
    return {
      UKFPSpayemntTemplate,
      SEPAPaymentTemplate,
      selectedAccountNumber: '',
      interBankFromAccount: '',
      selectedToAccountNumber: '',
      amount: '',
      interBankAmount: '',
      valid: true,
      paymentFrequency: '',
      interBankPaymentFrequency: '',
      noOfPayments: '',
      description: '',
      interBankPaymentDescription: '',
      addPayeeOtherBank: false,
      enablePaymentPage: true,
      enableOTPForRecurringPayments: this.$appSettings.defaultConfigurations
        .enableOTPForRecurringPayments,
      enableOTPForFuturePayments: this.$appSettings.defaultConfigurations
        .enableOTPForFuturePayments,
      showOTPScreen: false,
      amendPayload: '',
      renderComponent: true,
      showConfirmationModal: false,
      showLinkedAccounts: 0,
      futurePayment: false,
      selectedAccountBalance: '',
      fromAccountBalance: '',
      isFromAccountBalance: false,
      isValidateNextPaymentDate: false,
      isValidateEndDate: false,
      isFormValid: false,
      isInterBankFormValid: false,
      amendOrder: false,
      isPayeeFormValid: false,
      isFormAccounts: false,
      isAccountBalance: false,
      openPayee: false,
      enablePayeeForm: false,
      endDateMenu: false,
      search: '',
      searchPayee: '',
      listOfAccounts: [],
      selectedAccount: undefined,
      payeeAccount: '',
      transferAmount: '',
      transferNote: '',
      payeeList: '',
      payeeListInterBank: '',
      noOfPaymentsIntraBank: '',
      permissions: [],
      isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin')),
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess,
      fromDate: new Date().toISOString().substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
      nextPaymentDate: new Date().toISOString().substr(0, 10),
      pickInterBankPaymentDate: new Date().toISOString().substr(0, 10),
      minAllowedDate: new Date(Date.now()).toISOString().substr(0, 10),
      enableOTPToAddPayee: this.$appSettings.defaultConfigurations.enableOTPToAddPayee,
      otpSettings: {
        resetPasswordTime: this.$appSettings.defaultConfigurations
          .otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      payeeOtpModal: false,
      isLogout: false,
      formattedDate: '',
      formattedEndDate: '',
      formattedNextPaymentDate: '',
      nextExecutionDate: '',
      formattedInterBankPaymentDate: '',
      payeeCurrentTab: 0,
      isOwnAccountsOpted: true,
      isTransferComplete: false,
      modalConfig: {
        otp: {
          enabled: false,
          persistent: true,
          enableSave: true,
          close: true,
          saveButton: '',
          outlinedSaveBtn: false,
          title: this.$t('otp.toolBarTitle'),
          width: 400
        },
        amendSuccess: {
          enabled: false,
          persistent: true,
          title: this.$t('recurringAndFuturePayments.amendSuccessTitle'),
          btn2Label: this.$t('billPayments.goToDashboard'),
          width: 500
        }
      },
      quickPayment: {
        formattedDate: '',
        toAccount: '',
        isAccountBalance: false,
        fromDate: new Date().toISOString().substr(0, 10),
        reEnteredToAccount: '',
        selectedAccount: undefined,
        selectedAccountNumber: '',
        transferAmount: '',
        transferNote: '',
        isFormValid: false,
        toAccMaxLength: this.$appSettings.defaultConfigurations
          .fundTransferQuickPayToAccMaxlength
      },
      payeeForm: {
        toAccount: '',
        accountName: '',
        reEnteredToAccount: ''
      },
      totalPayeeTabs: [
        this.$t('transferfunds.payeeOwnAccount'),
        this.$t('transferfunds.payeeAccount')
      ],
      frequencyDays: [
        { state: this.$t('systemEnums.standingOrderFrequency.DAILY'), val: 'DAILY' },
        { state: this.$t('systemEnums.standingOrderFrequency.WEEKLY'), val: 'WEEKLY' },
        { state: this.$t('systemEnums.standingOrderFrequency.FORTNIGHTLY'), val: 'FORTNIGHTLY' },
        { state: this.$t('systemEnums.standingOrderFrequency.MONTHLY'), val: 'MONTHLY' },
        { state: this.$t('systemEnums.standingOrderFrequency.BI-MONTHLY'), val: 'BI-MONTHLY' },
        { state: this.$t('systemEnums.standingOrderFrequency.QUARTERLY'), val: 'QUARTERLY' },
        { state: this.$t('systemEnums.standingOrderFrequency.HALF-YEARLY'), val: 'HALF-YEARLY' },
        { state: this.$t('systemEnums.standingOrderFrequency.YEARLY'), val: 'YEARLY' }
      ],
      beneficiaryList: [],
      requiredRule: [(v) => Boolean(v) || 'Required Field'],
      rules: {
        requiredRule: (v) => Boolean(v) || 'Required Field',
        requiredWithNoErrRule: (v) => Boolean(v) || '',
        requiredAmountRule: (v) =>
          Boolean(v) || this.$t('errors.common.amountRequired'),
        numberTypeCheck: (v) =>
          new RegExp('^\\d+(\\.\\d\\d?)?$').test(v) ||
          this.$t('errors.common.invalidInput'),
        minValue: (v) => v >= 2 || this.$t('transferfunds.numberOfPaymentsMinValidation'),
        maxValue: (v) => v <= 10 || this.$t('transferfunds.numberOfPaymentsMaxValidation'),
        isAccBalanceValid: (v) =>
          v && v > 0
            ? !this.isAccountBalance || this.$t('domesticPayments.fundsError')
            : new RegExp('^0*(.0*)$').test(v) || v < 0
              ? this.$t('errors.common.minAmountError')
              : false,
        isLimitValid: () => {
          const self = this
          if (self.config.paymentInstruction.paymentSystem === 'STEP2') {
            return self.interBankAmount <= self.SEPAPaymentTemplate.transactionLimit ||
          self.$t('domesticPayments.limitError')
          } else {
            return self.interBankAmount <= self.UKFPSpayemntTemplate.transactionLimit ||
          self.$t('domesticPayments.limitError')
          }
        },
        transferNoteValidation: (v) =>
          new RegExp('^[a-zA-Z0-9\\.\\-\\,\\+\\(\\)\\|\\:\\?\\/]*$').test(v) ||
          this.$t('errors.common.invalidChar'),
        remarksFieldRule: (v) => {
          if (!v) return true
          const regex = /^[a-zA-Z0-9][a-zA-Z0-9',.\s-]*$/
          const isValid = regex.test(v)
          return isValid || this.$t('errors.common.invalidInput')
        }
      },
      enablePayeeFormInterBank: false,
      openPayeeInterBank: false,
      enableSortCodeSearchFormInterBank: false,
      searchPayeeInterBank: '',
      beneficiaryListInterBank: [],
      isPayeeFormValidInterBank: false,
      schema: {
        searchSortCodeForm: { exists: true }
      },
      searchSortCodeForm: {
        sortCode: '',
        branchName: '',
        bankName: '',
        isSearchAvailable: true,
        minInputLength: 5
      },
      payeeFormInterBank: {
        sortCode: '',
        toAccount: '',
        branchName: '',
        bankName: '',
        accountName: '',
        reEnteredToAccount: '',
        enableMaxPayeeName:
          this.$appSettings.defaultConfigurations.payeeNameMaxlength.interBank
      },
      ukfpsRemarksMaxlength: '',
      sepaRemarksMaxlength: '',
      intraBankRemarksMaxlength: this.$appSettings.defaultConfigurations.payments.intraBank.remarksMaxLength,
      isSortCodeSearchFormValidInterBank: false,
      sortCodeResultsInterBank: [],
      payeeAccountName: '',
      selectedPayeeSortCode: '',
      cashIsaTypes: ['TXEA'],
      allowInactiveAccountTransactionalOperations: this.$appSettings.defaultConfigurations.allowInactiveAccountTransactionalOperations,
      listOfAccountsLoaded: false,
      isUKFPSAccount: false,
      config: this.amendConfig
    }
  },
  async created () {
    this.ukfpsRemarksMaxlength = this.UKFPSpayemntTemplate.remarksMaxLength
    this.sepaRemarksMaxlength = this.SEPAPaymentTemplate.remarksMaxLength
    // Fetch Permissions for SME Users
    this.permissions = store.getters['profileStore/profileData']?.permissions
    await this.getFormData(`SearchSortCode-${this.$i18n.locale}`)
    this.isUKFPSAccount = this.config?.paymentInstruction?.paymentSystem === 'UKFPS'
    if (this.config.type === 'same') {
      if (this.config && this.config.fromAccountDescription) {
        this.selectedAccountNumber = this.config.fromAccountDescription
      }
      if (this.config) {
        this.amount = this.config.transferToAccountDetails[0].amount.value
        this.paymentFrequency = this.config.frequency
        this.fromDate = this.config.startDate
        this.formattedDate = this.$formatter.formatDate(this.fromDate)
        if (this.config.endDate) {
          this.endDate = this.config.endDate
        }
        if (this.config.numberOfPayments) {
          this.noOfPaymentsIntraBank = this.config.numberOfPayments
        }
        this.formattedEndDate = this.$formatter.formatDate(this.endDate)
        this.nextPaymentDate = this.config.nextPaymentDate
        this.formattedNextPaymentDate = this.$formatter.formatDate(this.nextPaymentDate)
        this.description = this.config.description
        this.payeeList = this.config.toAccountDescription
        this.selectedToAccountNumber = this.config.toAccountDescription
        this.payeeAccount = this.config.transferToAccountDetails[0].accountId
        this.getConfig(this.config)
      }
      this.formattedDate = this.$formatter.formatDate(this.fromDate)
      if (this.quickPayment && this.quickPayment.fromDate) {
        this.quickPayment.formattedDate = this.$formatter.formatDate(
          this.quickPayment.fromDate
        )
      }
      await this.getListofAccounts()
      if (this.config && this.config.transferFromAccountDetails && this.config.transferFromAccountDetails[0] && this.config.transferFromAccountDetails[0].accountId) {
        await this.getFromAccountBalance(this.config.transferFromAccountDetails[0].accountId)
      }
      if (this.$route.params && this.$route.params.accountNumber) {
        this.selectedAccountNumber = this.$route.params.accountNumber
        this.quickPayment.selectedAccountNumber = this.$route.params.accountNumber
        this.verifyAccount()
      }
      if (this.$route.params && this.$route.params.beneficiaryAccount) {
        this.payeeList = this.$route.params.beneficiaryAccount
      }
    } else {
      this.interBankFromAccount = this.config.debtorAccountDescription
      this.interBankAmount = this.config.paymentInstruction.instructionAmount.amount
      this.interBankPaymentFrequency = this.config.standingOrderSetup.frequency
      this.noOfPayments = this.config.standingOrderSetup.numberOfPayments
      this.interBankPaymentDescription = this.config.description
      this.formattedInterBankPaymentDate = this.$formatter.formatDate(this.config.standingOrderSetup.fromDate)
      this.pickInterBankPaymentDate = this.$formatter.formatDate(this.config.standingOrderSetup.fromDate)
      this.nextExecutionDate = this.$formatter.formatDate(this.config.standingOrderSetup.nextExecutionDate)
      this.payeeAccountName = this.config.paymentInstruction.cdtrAccount
      this.payeeAccount = this.config.paymentInstruction.cdtrAccount
      this.payeeListInterBank = this.config.paymentInstruction.cdtrName
      this.selectedPayeeSortCode = this.config.paymentInstruction.cdtrBankIdentifier
      this.getConfig(this.config)
      await this.getExistingPayeeListInterBank()
      await this.getFromAccountBalance(this.config.debtorAccountNum)
    }
    event.$on('navigateToAmend', async (args) => {
      this.renderComponent = true
      this.config = args
      this.amount = this.config.transferToAccountDetails[0].amount.value
      this.paymentFrequency = this.config.frequency
      this.fromDate = this.config.startDate
      this.formattedDate = this.$formatter.formatDate(this.fromDate)
      if (this.config.endDate) {
        this.endDate = this.config.endDate
      }
      if (this.config.numberOfPayments) {
        this.noOfPaymentsIntraBank = this.config.numberOfPayments
      }
      this.formattedEndDate = this.$formatter.formatDate(this.endDate)
      this.nextPaymentDate = this.config.nextPaymentDate
      this.formattedNextPaymentDate = this.$formatter.formatDate(this.nextPaymentDate)
      this.description = this.config.description
      this.payeeList = this.config.toAccountDescription
      this.selectedAccountNumber = this.config.fromAccountDescription
      this.selectedToAccountNumber = this.config.toAccountDescription
      this.payeeAccount = this.config.transferToAccountDetails[0].accountId
      this.getConfig(this.config)
      await this.getListofAccounts()
      await this.getFromAccountBalance(this.config.transferFromAccountDetails[0].accountId)
    })
    event.$on('amendInterBankPayment', async (args) => {
      this.config = args
      this.interBankFromAccount = this.config.debtorAccountDescription
      this.interBankAmount = this.config.paymentInstruction.instructionAmount.amount
      this.interBankPaymentFrequency = this.config.standingOrderSetup.frequency
      this.noOfPayments = this.config.standingOrderSetup.numberOfPayments
      this.interBankPaymentDescription = this.config.description
      this.formattedInterBankPaymentDate = this.$formatter.formatDate(this.config.standingOrderSetup.fromDate)
      this.pickInterBankPaymentDate = this.$formatter.formatDate(this.config.standingOrderSetup.fromDate)
      this.nextExecutionDate = this.$formatter.formatDate(this.config.standingOrderSetup.nextExecutionDate)
      this.payeeAccountName = this.config.paymentInstruction.cdtrAccount
      this.payeeAccount = this.config.paymentInstruction.cdtrAccount
      this.payeeListInterBank = this.config.paymentInstruction.cdtrName
      this.selectedPayeeSortCode = this.config.paymentInstruction.cdtrBankIdentifier
      this.getConfig(this.config)
      await this.getExistingPayeeListInterBank()
      await this.getFromAccountBalance(this.config.debtorAccountNum)
    })
    event.$on('is_TransferComplete', (status) => {
      this.isTransferComplete = status
    })
    event.$on('IS_OTP_VALID', (valid) => {
      if (valid) {
        this.amendOrder = true
        if (this.enableOTPToAddPayee && this.showOTPScreen && this.config.type === 'other' && this.addPayeeOtherBank) {
          this.modalConfig.otp.enabled = false
          this.addNewPayeeInterBank()
        }
        if (!this.enablePaymentPage && !this.futurePayment && this.enableOTPForRecurringPayments && this.showOTPScreen && this.config.type === 'same') {
          this.amendDetails()
        }
        if (!this.enablePaymentPage && !this.futurePayment && this.enableOTPForRecurringPayments && this.showOTPScreen && this.config.type === 'other' && !this.addPayeeOtherBank) {
          this.amendDetailsInterBank()
        }
        if (!this.enablePaymentPage && this.futurePayment && this.enableOTPForFuturePayments && this.showOTPScreen && this.config.type === 'same') {
          this.amendDetails()
        }
        if (!this.enablePaymentPage && this.futurePayment && this.enableOTPForFuturePayments && this.showOTPScreen && this.config.type === 'other') {
          this.amendDetailsInterBank()
        }
        if (this.enableOTPToAddPayee && !this.futurePayment && this.showOTPScreen && this.payeeOtpModal) {
          this.modalConfig.otp.enabled = false
          this.addNewPayee()
        }
      } else {
        this.amendOrder = false
      }
    })
    event.$on('OTP_RESENT', (val) => {
      this.modalConfig.otp.enableSave = true
    })
    event.$on('depositPristineLogout', (arg) => {
      this.isLogout = arg
    })
    event.$on('open_userProfile', (isOpen) => {
      this.openPayeeInterBank = false
    })
  },
  computed: {
    payeeSearchFilterInterBank () {
      if (this.beneficiaryListInterBank.length) {
        let temp = []
        temp = this.beneficiaryListInterBank.filter(item => {
          return this.showLinkedAccounts === 0 ? item.ownAccount === true : item.ownAccount === false
        }).filter(item => {
          return this.config.isSEPAaccount ? item.paymentSystem === 'STEP2' : item.paymentSystem === 'UKFPS'
        })
        return _.orderBy(
          temp.filter((item) => {
            if (!this.searchPayeeInterBank) return temp
            return (
              item.name
                .toLowerCase()
                .includes(this.searchPayeeInterBank.toLowerCase()) ||
                item.accountIdentification
                  .toLowerCase()
                  .includes(this.searchPayeeInterBank.toLowerCase())
            )
          })
        )
      } else return 0
    },
    getInterBankAmountLimit () {
      if (this.config.paymentInstruction.paymentSystem === 'UKFPS') {
        return `${this.$t('domesticPayments.maxAmountLimit')}  - ${this.$formatter.currency.format(
                            this.UKFPSpayemntTemplate.transactionLimit,
                            this.UKFPSpayemntTemplate.currency
                          )}`
      } else {
        return `${this.$t('internationalPayments.maxAmountLimit')} - ${this.$formatter.currency.format(
                this.SEPAPaymentTemplate.transactionLimit,
                this.SEPAPaymentTemplate.currency
                )}`
      }
    },
    filteredItems () {
      if (this.listOfAccounts?.causes) return []

      const fromAccCurrency = this.config.transferFromAccountDetails[0]?.amount?.currency
      const cashIsaTypes = ['TXFR', 'TXNA', 'TXEA']
      const isSourceCashIsa = cashIsaTypes.includes(this.config.fromAccTypeCode)
      if (!this.futurePayment) {
        return _.orderBy(
          this.listOfAccounts.filter(acc => {
            const isValidAccountType = ['TXEA', 'TXNA', 'SVGS', 'CACC', 'NACC'].includes(acc.accountType)
            const isSameCurrency = acc.currency === fromAccCurrency
            const isValidStatus = !(acc.accountStatus === 'INACTIVE' && !this.allowInactiveAccountTransactionalOperations)
            const isTargetCashIsa = cashIsaTypes.includes(acc.accountType)
            const isAllowedPaymentsToOtherIsa = (isSourceCashIsa && isTargetCashIsa) ? this.allowPaymentsToOtherISA : true
            const isSavingsAccountTypePermittedForSme = (this.isSmePermissionCheckEnabled && !this.permissions?.includes('SAVING_VIEW_DETAILS')) ? ('SVGS' !== acc.accountType) : true
            const isCurrentAccountTypePermittedForSme = (this.isSmePermissionCheckEnabled && !this.permissions?.includes('CURRENT_VIEW_DETAILS')) ? ('CACC' !== acc.accountType) : true
            const isNoticeAccountTypePermittedForSme = (this.isSmePermissionCheckEnabled && !this.permissions?.includes('NOTICE_VIEW_DETAILS')) ? ('NACC' !== acc.accountType) : true

            return isValidAccountType && isSameCurrency && isValidStatus && isAllowedPaymentsToOtherIsa && this.matchesSearch(this.search, acc)
              && isSavingsAccountTypePermittedForSme && isCurrentAccountTypePermittedForSme && isNoticeAccountTypePermittedForSme
          }))
      }
      return _.orderBy(this.listOfAccounts)
    },
    getPaymentSuccessDialogConfig () {
      return {
        ...this.modalConfig.amendSuccess,
        enabled: this.showConfirmationModal,
        body: !this.futurePayment ? this.$t('recurringAndFuturePayments.amendRecurringPaymentSuccessMessage') : this.$t('recurringAndFuturePayments.amendFuturePaymentSuccessMessage'),
        btn1Label: !this.futurePayment ? this.$t('recurringAndFuturePayments.goToRecurringPaymentsList') : this.$t('recurringAndFuturePayments.goToFuturePaymentsList')
      }
    },
    isViewPayeePermitted () {
      return (this.isSmeLogin && this.enableRoleBasedAccess) ? this.permissions?.includes('VIEW_PAYEES') : true
    },
    isAddPayeePermitted () {
      return (this.isSmeLogin && this.enableRoleBasedAccess) ? this.permissions?.includes('ADD_AND_DELETE_SAME_BANK_PAYEES') : true
    }
  },
  methods: {
    isSmePermissionCheckEnabled: () => this.isSmeLogin && this.enableRoleBasedAccess,
    getConfig (config) {
      if (config.startDate && config.endDate && config.frequency === 'DAILY') {
        const startDate = moment(config.startDate, 'YYYY-MM-DD')
        const endDate = moment(config.endDate, 'YYYY-MM-DD')
        const diff = endDate.diff(startDate, 'days')
        if (diff === 1) {
          this.futurePayment = true
        } else {
          this.futurePayment = false
        }
      }
      if (config.startDate && config.nextPaymentDate && config.frequency === 'DAILY') {
        const startDate = moment(config.startDate, 'YYYY-MM-DD')
        const nextPaymentDate = moment(config.nextPaymentDate, 'YYYY-MM-DD')
        if ((nextPaymentDate >= startDate) && config.numberOfPayments === 1 && config.frequency === 'DAILY') {
          this.futurePayment = true
        } else {
          this.futurePayment = false
        }
      }
      if (config.type === 'other') {
        if (config.standingOrderSetup && config.standingOrderSetup.numberOfPayments === 1 && config.standingOrderSetup.frequency === 'DAILY') {
          this.futurePayment = true
        } else {
          this.futurePayment = false
        }
      }
    },
    onOtpModalClose () {
      this.enablePaymentPage = false
      this.showOTPScreen = false
      this.modalConfig.otp.enabled = false
    },
    setOtpComp () {
      if (!this.futurePayment && this.enableOTPForRecurringPayments) {
        // create acc WITH otp Authentication
        this.addPayeeOtherBank = false
        this.enablePaymentPage = false
        this.showOTPScreen = true
        this.modalConfig.otp.enabled = true
        this.modalConfig.otp.enableSave = true
      } else if (this.futurePayment && this.enableOTPForFuturePayments) {
        this.enablePaymentPage = false
        this.showOTPScreen = true
        this.modalConfig.otp.enabled = true
        this.modalConfig.otp.enableSave = true
      } else {
        // call Bill Payment WITHOUT otp Authentication
        this.config.type === 'same' ? this.amendDetails(this.config) : this.amendInterBankStandingOrder(this.config)
      }
    },
    amendDetails () {
      // this.onOtpModalClose()
      this.amendStandingOrder(this.config)
    },
    amendDetailsInterBank () {
      // this.onOtpModalClose()
      this.amendInterBankStandingOrder(this.config)
    },
    handleOTPError (res) {
      if (res?.internalType === 'OTP-ERROR') {
        event.$emit('otp_validation_failed', res)
        return
      }

      this.onOtpModalClose()
    },
    async amendInterBankStandingOrder (config) {
      const payload = {}
      payload.standingOrderStatus = config.standingOrderStatus
      payload.customerId = config.customerId
      payload.description = config.description
      payload.paymentInstruction = config.paymentInstruction
      payload.standingOrderSetup = config.standingOrderSetup
      payload.channelId = config.channelId
      payload.paymentInstruction.cdtrAccount = this.payeeAccount
      payload.paymentInstruction.cdtrName = this.payeeListInterBank
      payload.paymentInstruction.instructionAmount.amount = this.interBankAmount
      payload.standingOrderSetup.frequency = this.interBankPaymentFrequency.val ? this.interBankPaymentFrequency.val : this.interBankPaymentFrequency
      payload.standingOrderSetup.numberOfPayments = this.noOfPayments
      payload.description = this.interBankPaymentDescription
      delete payload.standingOrderSetup.toDate
      if (payload.standingOrderSetup.frequency === 'MONTHLY') {
        payload.standingOrderSetup.endOfMonth = true
      } else {
        delete payload.standingOrderSetup.endOfMonth
      }
      payload.paymentInstruction.chargeAmount = {
        amount: 0.00,
        currency: 'GBP'
      }
      payload.paymentInstruction.taxAmount = {
        amount: 0.00,
        currency: 'GBP'
      }
      const response = await CommonService.amendInterBankStandingOrder(config.standingOrderId, payload)
      if (response.standingOrderId) {
        this.showConfirmationModal = true
        this.selectedPayeeSortCode = ''
      }
      this.handleOTPError(response)
    },
    navigateToList (reloadList) {
      this.openPayee = false
      this.renderComponent = false
      this.showConfirmationModal = false
      this.isFormAccounts = false
      this.isFromAccountBalance = false
      this.isValidateEndDate = false
      this.search = ''
      if (this.futurePayment) {
        this.futurePayment = false
      }
      event.$emit('disableFuturePaymentDetails', true)
      event.$emit('goToStandingOrderList', reloadList)
    },
    convertToCapitalisedSentence (sentence) {
      return this.$formatter.convertCase.convertToCapitalisedSentence(sentence)
    },
    navigateToDashboard () {
      this.$router.push({ path: '/home' })
    },
    closePayeeForm () {
      this.enablePayeeForm = false
      // clears all fields
      this.$refs.payeeForm.reset()
    },
    onAddPayee () {
      if (this.enableOTPToAddPayee) {
        this.payeeOtpModal = true
        this.showOTPScreen = true
        this.modalConfig.otp.enabled = true
      } else {
        this.addNewPayee()
      }
    },
    async amendStandingOrder (config) {
      try {
        this.amendPayload = {
          description: this.description,
          startDate: this.fromDate,
          frequency: this.paymentFrequency.val ? this.paymentFrequency.val : this.paymentFrequency,
          transferFromAccountDetails: [
            {
              accountId: config.transferFromAccountDetails[0].accountId,
              amount: {
                value: this.amount,
                currency: config.transferFromAccountDetails[0].amount.currency
              }
            }
          ],
          transferToAccountDetails: [
            {
              accountId: this.payeeAccount,
              amount: {
                value: this.amount,
                currency: config.transferToAccountDetails[0].amount.currency
              }
            }
          ]
        }
        if (config.endDate) {
          this.amendPayload.endDate = this.endDate
        } else if (config.numberOfPayments) {
          this.amendPayload.numberOfPayments = this.noOfPaymentsIntraBank
        }
        const amendResponse = await CommonService.amendStandingOrder(this.amendPayload, config.standingOrderId)
        if (amendResponse.standingOrderId) {
          this.showConfirmationModal = true
        }

        this.handleOTPError(amendResponse)
      } catch (e) {
        console.log(e)
      }
    },

    async addNewPayee () {
      this.showOTPScreen = false
      this.modalConfig.otp.enabled = false
      this.$refs.payeeForm.validate()
      try {
        const payeePayload = {
          customerId: JSON.parse(sessionStorage.getItem('username')),
          beneficiaryAccount: this.payeeForm.toAccount,
          beneficiaryReference: this.payeeForm.accountName
        }
        const response = await CommonService.createIntraPayeeAccount(payeePayload)
        if (response && !response.causes && response.customerId) {
          this.$refs.payeeForm.reset()
          this.enablePayeeForm = false
          this.$store.dispatch('appStore/setAppData', {
            message: {
              content: this.$t('transferfunds.addPayeeSuccessMsg'),
              type: 'success',
              component: 'dob-snackbar'
            }
          })
          // Refresh Existing Payee List
          await this.getExistingPayeeList()
        }
      } catch (e) {
        console.log(e)
      }
    },
    isNumberMatched (firstVal, secondVal) {
      return firstVal && secondVal ? firstVal !== secondVal : false
    },
    async getListofAccounts () {
      this.listOfAccountsLoaded = false
      this.listOfAccounts = await preload.getAllCASAWithBalance(
        JSON.parse(sessionStorage.getItem('username'))
      )
      this.listOfAccountsLoaded = true
    },
    async getFromAccountBalance (accountNumber) {
      let fromAccBal, currencyCode
      if (this.config.fromAccTypeCode === 'TXEA') {
        const accountBalances = await CommonService.getNoticeAccountBalances(accountNumber)
        if (accountBalances && accountBalances.balanceInformation) {
          fromAccBal = accountBalances.balanceInformation.availableBalance
          currencyCode = accountBalances.basicInformation.isoCurrencyCode
        }
      } else {
        const accountBalances = await CommonService.getAccountBalances(accountNumber)
        if (accountBalances) {
          accountBalances.balances.forEach(key => {
            if (key.balanceType === 'INTERIMAVAILABLE') {
              fromAccBal = key.amount.amount
              currencyCode = key.amount.currency
            }
          })
        }
      }

      this.fromAccountBalance = this.selectedAccountBalance = fromAccBal
      this.selectedAccountNumber = this.selectedAccountNumber + ` - (${this.$t('common.balLabel')} ${this.$formatter.currency.format(this.selectedAccountBalance, currencyCode)})`
      this.interBankFromAccount = `${this.config.debtorAccountDescription}  - (${this.$t('common.balLabel')} ${this.$formatter.currency.format(this.selectedAccountBalance, currencyCode)})`
    },
    validateBalance (amendType = null) {
      if (amendType === 'interBankAmount') {
        this.isFromAccountBalance = Number(this.interBankAmount) > Number(this.fromAccountBalance)
      } else {
        this.isFromAccountBalance = Number(this.amount) > Number(this.fromAccountBalance)
      }
    },
    togglePayee (index) {
      this.payeeAccount = index.accountId || index.beneficiaryAccount
      if (index && index.accountType) {
        const accTypeLabel = getAccountTypeLabel(index.accountType)
        this.payeeList = `${accTypeLabel} - ${index.accountId}`
      } else if (index && index.beneficiaryAccount) {
        this.payeeList = index.beneficiaryAccount
      }
      this.openPayee = !this.openPayee
      this.verifyAccount()
    },
    allowedDates: (val) => parseInt(val.split('-')[2], 10) % 1 === 0,
    listPayee () {
      this.openPayee = !this.openPayee
    },
    updateEndDate () {
      this.formattedEndDate = this.$formatter.formatDate(this.endDate)
      if (this.endDate < this.nextPaymentDate) {
        this.isValidateEndDate = true
      } else {
        this.isValidateEndDate = false
      }
    },
    updateNextPaymentDate () {
      this.formattedNextPaymentDate = this.$formatter.formatDate(this.nextPaymentDate)
      if (this.endDate < this.nextPaymentDate) {
        this.isValidateNextPaymentDate = true
      } else {
        this.isValidateNextPaymentDate = false
      }
    },
    verifyAccount () {
      if (this.config && this.payeeAccount) {
        if (this.config.transferFromAccountDetails && this.config.transferFromAccountDetails[0].accountId === this.payeeAccount) {
          this.isFormAccounts = true
        } else {
          this.isFormAccounts = false
        }
      }
      this.listOfAccounts.forEach((acc) => {
        const selectedType = this.selectedAccountNumber
          ? 'default'
          : 'quickPayment'
        switch (selectedType) {
          case 'quickPayment':
            if (acc.accountId === this.quickPayment.selectedAccountNumber) {
              this.quickPayment.selectedAccount = acc
              this.quickPayment.transferAmount = ''
              this.quickPayment.isAccountBalance = false
            }
            break
          default:
            if (acc.accountId === this.selectedAccountNumber) {
              this.selectedAccount = acc
              this.selectedAccountNumber === this.payeeAccount
                ? (this.isFormAccounts = true)
                : (this.isFormAccounts = false)
              this.transferAmount = ''
              this.isAccountBalance = false
            }
            break
        }
      })
    },
    async getExistingPayeeList () {
      try {
        const response = await CommonService.getIntraBankPayeeList(
          JSON.parse(sessionStorage.getItem('username'))
        )
        if (response && response.beneficiaryList) {
          this.beneficiaryList = response.beneficiaryList
        }
      } catch (e) {
        console.log(e)
      }
    },
    isNumberMatchedInterBank (firstVal, secondVal) {
      return firstVal && secondVal ? firstVal !== secondVal : false
    },
    onAddPayeeInterBank () {
      this.validatePayeeAccount()
    },
    maskSortCodeInterBank (code) {
      let maskedCode = ''
      if (code) {
        const sortCode = code.toString()
        for (let i = 0; i < sortCode.length; i++) {
          if (i % 2 === 0) {
            maskedCode = maskedCode + sortCode.substr(i, 2)
          } else if (i !== sortCode.length - 1) {
            maskedCode = maskedCode + '-'
          }
        }
      }
      return code ? maskedCode : ''
    },
    removeMasking (code) {
      return code ? code.replace(/-/g, '') : ''
    },
    async onSearchSortCodeInterBank () {
      const searchPayload = {
        networkName: 'UKFPS',
        branch: this.schema.searchSortCodeForm.model.branchName,
        bankName: this.schema.searchSortCodeForm.model.bankName,
        directoryIdentifier: this.removeMasking(
          this.schema.searchSortCodeForm.model.sortCode
        ),
        reachability: 'A',
        wildCardSearch: true
      }
      const searchResponse = await CommonService.searchUkfpsSortCode(
        searchPayload
      )
      if (searchResponse && !searchResponse.causes) {
        this.sortCodeResultsInterBank = searchResponse
      }
      if (!searchResponse.length) {
        this.searchSortCodeForm.isSearchAvailable = false
      }
    },
    convertToCapitalised (sentence) {
      let capitalizedSentence = ''
      if (sentence) {
        const words = sentence.split(' ')
        capitalizedSentence = words
          .map((word) => {
            return word[0].toUpperCase() + word.substring(1).toLowerCase()
          })
          .join(' ')
      }
      return sentence ? capitalizedSentence : ''
    },
    async getFormData (formName) {
      try {
        const componentSchema = await CommonService.getFormData(formName)
        const data = getFormConfig(componentSchema)
        this.schema.searchSortCodeForm = data
        event.$on('isValid', (arg) => {
          this.isSortCodeSearchFormValidInterBank = arg
        })
      } catch (e) {
        console.log(e)
      }
    },
    isSearchDataValidInterBank () {
      if (this.schema.searchSortCodeForm.model && this.schema.searchSortCodeForm.model.sortCode) {
        this.schema.searchSortCodeForm.schema.sortCode.regex = '^([\\d \\w]{2}-[\\d \\w]{2}-[\\d \\w]{2})*$'
      } else { this.schema.searchSortCodeForm.schema.sortCode.regex = '' }
      if (this.schema.searchSortCodeForm.model && this.schema.searchSortCodeForm.model.bankName) {
        this.schema.searchSortCodeForm.schema.bankName.rules = [minLen(5, 5)]
      } else { this.schema.searchSortCodeForm.schema.bankName.rules = [] }
      if (this.schema.searchSortCodeForm.model && this.schema.searchSortCodeForm.model.branchName) {
        this.schema.searchSortCodeForm.schema.branchName.rules = [minLen(5, 5)]
      } else { this.schema.searchSortCodeForm.schema.branchName.rules = [] }

      if (
        this.schema.searchSortCodeForm.model && this.schema.searchSortCodeForm.model.bankName &&
        this.schema.searchSortCodeForm.model.branchName && this.isSortCodeSearchFormValidInterBank) {
        return false
      } else if (
        this.schema.searchSortCodeForm.model && this.schema.searchSortCodeForm.model.sortCode &&
        this.isSortCodeSearchFormValidInterBank
      ) {
        return false
      } else return true
    },
    async getExistingPayeeListInterBank () {
      try {
        const response = await CommonService.getBeneficiaries(
          JSON.parse(sessionStorage.getItem('username'))
        )
        if (response && response.items) {
          this.beneficiaryListInterBank = response.items
        }
      } catch (e) {
        console.log(e)
      }
    },
    getPayeeDetails () {
      const self = this
      for (const item of this.beneficiaryListInterBank) {
        if (item.accountIdentification === self.payeeAccount) return item
      }
      return false
    },
    showDividerInterBank (index, array) {
      return array.length ? index + 1 < array.length : false
    },
    resetPage () {
      // clears all fields
      if (this.$refs.form) {
        this.$refs.form.reset()
        this.fromDate = new Date().toISOString().substr(0, 10)
      }
      if (this.$refs.quickPaymentForm) {
        this.$refs.quickPaymentForm.reset()
      }
      // resets screens
      this.reviewScreen = false
      this.isFormValid = false
      this.isAccountBalance = false
      this.isTransferComplete = false
      this.quickPayment.isFormValid = false
      this.quickPayment.isAccountBalance = false
      this.openPayeeInterBank = false
      setTimeout(() => {
        this.resetDate()
      }, 100)
    },
    onClosePayeeDrawerInterBank () {
      if (!this.enablePayeeFormInterBank && !this.enableSortCodeSearchFormInterBank) {
        this.openPayeeInterBank = !this.openPayeeInterBank
      }
      if (this.enableSortCodeSearchFormInterBank) {
        // clears all search sortcode fields
        this.$refs.searchSortCodeForm.reset()
        this.sortCodeResultsInterBank = []
        this.searchSortCodeForm.isSearchAvailable = false
        this.enableSortCodeSearchFormInterBank = false
        this.enablePayeeFormInterBank = true
      } else {
        // clears all fields
        if (this.$refs.payeeFormInterBank) {
          this.$refs.payeeFormInterBank.reset()
        }

        this.enablePayeeFormInterBank = false
      }
    },
    togglePayeeInterBank (index) {
      this.payeeAccount = index.accountIdentification
      this.payeeAccountName = index.accountIdentification
      this.selectedPayeeSortCode = index.bankIdentifier
      this.payeeListInterBank = index.name
      this.openPayeeInterBank = !this.openPayeeInterBank
      this.verifyAccount('selectPayee')
    },
    async listPayeeInterBank () {
      if (!this.openPayeeInterBank) {
        await this.getExistingPayeeListInterBank()
      }
      this.openPayeeInterBank = !this.openPayeeInterBank
    },
    showSearchFormInterBank () {
      this.enablePayeeFormInterBank = false
      this.enableSortCodeSearchFormInterBank = true
      this.sortCodeResultsInterBank = []
      this.searchSortCodeForm.isSearchAvailable = true
    },
    onSortCodeSelectInterBank (data) {
      this.enablePayeeFormInterBank = true
      this.enableSortCodeSearchFormInterBank = false
      // clears all search sortcode fields
      this.schema.searchSortCodeForm.model.sortCode = ''
      this.schema.searchSortCodeForm.model.branchName = ''
      this.schema.searchSortCodeForm.model.bankName = ''
      this.payeeFormInterBank.sortCode = data.nationalid ? this.maskSortCodeInterBank(data.nationalid) : ''
      this.payeeFormInterBank.bankName = data.instname ? this.convertToCapitalised(data.instname) : ''
    },
    async validatePayeeAccount () {
      this.$refs.payeeFormInterBank.validate()
      try {
        const validatePayload = {
          accountNumber: this.payeeFormInterBank.toAccount,
          type: 'UKFPS',
          hostId: 'MPM',
          sortCode: this.removeMasking(this.payeeFormInterBank.sortCode)
        }
        const response = await CommonService.validateAccount(validatePayload)
        if (response && !response.causes && response.valid) {
          if (this.enableOTPToAddPayee) {
            this.addPayeeOtherBank = true
            this.showOTPScreen = true
            this.modalConfig.otp.enabled = true
          } else {
            this.addNewPayeeInterBank()
          }
        } else {
          this.$store.dispatch('appStore/setAppData', {
            message: {
              title: 'Error',
              width: 400,
              persistent: true,
              saveButton: this.$t('common.okay'),
              content: this.$t('domesticPayments.validatePayeeError'),
              type: 'error',
              component: 'dob-modal'
            }
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
    async addNewPayeeInterBank () {
      this.onOtpModalClose()
      try {
        const storeData = this.$store.getters['profileStore/profileData']
        const customerFullName = storeData.customerDetails
          ? storeData.fullName
          : ''
        const payeePayload = {
          customerId: JSON.parse(sessionStorage.getItem('username')),
          name: this.payeeFormInterBank.accountName || customerFullName,
          accountIdentificationType: 'PROPRIETARY',
          accountIdentification: this.payeeFormInterBank.toAccount,
          country: this.UKFPSpayemntTemplate.country,
          currency: this.UKFPSpayemntTemplate.currency,
          paymentSystem: 'UKFPS',
          bankIdentifier: this.removeMasking(this.payeeFormInterBank.sortCode),
          ownAccount: false
        }
        const response = await CommonService.createBeneficiaryAccount(
          payeePayload
        )
        if (response && !response.causes && response.details.customerId) {
          this.$refs.payeeFormInterBank.reset()
          this.enablePayeeFormInterBank = false
          this.enableSortCodeSearchFormInterBank = false
          this.$store.dispatch('appStore/setAppData', {
            message: {
              content: this.$t('domesticPayments.addPayeeSuccessMsg'),
              type: 'success',
              component: 'dob-snackbar'
            }
          })
          // Refresh Existing Payee List
          await this.getExistingPayeeListInterBank()
        } else {
          if (response && response.causes[0] && response.causes[0].code === '20600064') {
            return
          } else {
            this.$store.dispatch('appStore/setAppData', {
              message: {
                title: 'Error',
                width: 400,
                persistent: true,
                saveButton: this.$t('common.okay'),
                content: this.$t('domesticPayments.addNewPayeeError'),
                type: 'error',
                component: 'dob-modal'
              }
            })
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    formatAccount ({ accountType, accountId, balance, currency }) {
      const accountTypeLabel = getAccountTypeLabel(accountType)
      const balLabel = this.$t('common.balLabel')
      const amount = this.$formatter.currency.format(balance, currency)
      return `${accountTypeLabel} - ${accountId} - (${balLabel} ${amount})`
    },
    matchesSearch ({ accountName, accountId, iban }) {
      if (!this.search) return true

      const searchLower = this.search.toLowerCase()
      return accountName.toLowerCase().includes(searchLower) ||
        accountId.toLowerCase().includes(searchLower) ||
        (iban ? iban.toLowerCase().includes(searchLower) : false)
    }
  },
  watch: {
    currentTab () {
      if (this.openPayee) {
        this.openPayee = false
      }
    },
    showOTPScreen () {
      if (!this.futurePayment) {
        if ((this.enableOTPForRecurringPayments && this.showOTPScreen) || (this.enableOTPToAddPayee && this.showOTPScreen)) {
          setTimeout(() => {
            event.$emit('SEND_OTP', true)
          }, 200)
        }
      }
      if (this.futurePayment) {
        if ((this.enableOTPForFuturePayments && this.showOTPScreen) || (this.enableOTPToAddPayee && this.showOTPScreen)) {
          setTimeout(() => {
            event.$emit('SEND_OTP', true)
          }, 200)
        }
      }
    },
    payeeCurrentTab () {
      this.isOwnAccountsOpted = this.payeeCurrentTab === 0
      if (this.payeeCurrentTab === 1) {
        this.getExistingPayeeList()
      }
    }
  }
}
</script>
